import type { SVGProps } from "react";
export default function SvgMicrosoft(props: SVGProps<SVGSVGElement>) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="1em"
			height="1em"
			viewBox="0 0 21 21"
			{...props}
		>
			<rect width={9} height={9} x={1} y={1} fill="#f25022" />
			<rect width={9} height={9} x={1} y={11} fill="#00a4ef" />
			<rect width={9} height={9} x={11} y={1} fill="#7fba00" />
			<rect width={9} height={9} x={11} y={11} fill="#ffb900" />
		</svg>
	);
}
